module.exports = __webpack_public_path__ + "media/images/icon-linkedin-14f1f7369e6ab0f50a1937a855674c02.svg";